export const FIELD_DEFINITIONS = {
  template: {
    title: 'Template',
    component: 'textarea',
    rows: 20,
  },
  mail_subject: {
    title: 'Onderwerp',
    component: 'text',
  },
};

export const CHANNEL_LABELS = {
  email: 'E-mail',
  sms: 'SMS',
};
